import { VimeoIcon } from '../../../assets/icons/vimeo';
import { createEmbedProvider } from '../factory';

/**
 * Vimeo URL regex pattern
 * Matches: vimeo.com/*, player.vimeo.com/video/*, channels/*, groups/*, etc.
 * Trailing .* allows invisible chars from rich text editors - replace() cleans before validation.
 */
export const VIMEO_REGEX =
  /^(https?:)?\/\/(?:(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)|player\.vimeo\.com\/video\/)(\d+)(?:\/([a-zA-Z0-9]+))?(?:\?[^\s]*)?.*$/i;

const extractHash = (url: string, pathHash: string | undefined): string | undefined => {
  if (pathHash) return pathHash;

  // Try to extract h= from query params
  try {
    const normalized = url.startsWith('//') ? `https:${url}` : url;
    const h = new URL(normalized).searchParams.get('h');

    return h || undefined;
  } catch {
    return undefined;
  }
};

export const vimeoProvider = createEmbedProvider({
  id: 'vimeo',
  label: 'Vimeo Video',
  icon: <VimeoIcon className="size-5 fill-current" />,
  regex: VIMEO_REGEX,
  buildEmbedUrl: (match, cleanedUrl) => {
    const videoId = match[3];
    const hId = extractHash(cleanedUrl, match[4]);

    return `https://player.vimeo.com/video/${videoId}?byline=0${hId ? `&h=${hId}` : ''}`;
  },
});
